module.exports = __webpack_public_path__ + "img/10.0347b3d7.jpg";